(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('confirm', confirm);

    var slice = Array.prototype.slice,
        identity = angular.identity;

    confirm.$inject = ['$uibModal', 'gettextCatalog'];
    function confirm($uibModal, gettextCatalog) {
        return function confirm(message, params) {
            params = slice.call(arguments, 1);
            message = message.format.apply(gettextCatalog.getString(message), params);

            return $uibModal.open({
                component: 'sc3Confirm',
                resolve: { message: identity.bind(null, message) },
                windowClass: 'sc3-confirm-modal',
                keyboard: false, 
                backdrop: 'static'
            }).result;
        };
    }
})();